export function getErrorMessage(error, fallback = "操作失败") {
  const data = error?.response?.data;
  const detail = data?.detail;

  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const message = detail
      .map((item) => item?.msg || item?.message || item?.detail || JSON.stringify(item))
      .filter(Boolean)
      .join("\n");
    if (message) return message;
  }

  if (detail && typeof detail === "object") {
    return detail.message || detail.msg || JSON.stringify(detail);
  }

  if (typeof data === "string" && data.trim()) {
    return data;
  }

  if (data && typeof data === "object") {
    return data.message || data.msg || fallback;
  }

  return error?.message || fallback;
}
